import {TFunction} from "i18next";
import {
  type GraphqlErrorLike,
  isGraphqlErrorLike
} from "../../../../amplify/hooks/types";

/**
 * Formats tenant creation errors with user-friendly messages
 * for the simple hierarchy creation flow.
 * Uses duck-typed GraphqlErrorLike so it works with both Apollo and Amplify errors.
 */
export const formatTenantCreationError = (
  error: GraphqlErrorLike | Error,
  tenantName: string,
  t: TFunction
): Error => {
  if (isGraphqlErrorLike(error)) {
    if (error.networkError) {
      return new Error(
        t("create-operational-hierarchy.errors.tenant.network-error-detail")
      );
    }

    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      const graphQLError = error.graphQLErrors[0];
      const errorMessage = graphQLError?.message || error.message;
      return new Error(
        t("create-operational-hierarchy.errors.tenant.graphql-error-detail", {
          errorMessage
        })
      );
    }
  }

  return new Error(
    t("create-operational-hierarchy.errors.tenant.creation-failed-detail", {
      tenantName
    })
  );
};
